<template>
  <div class="wnds_news">
    <div class="wn_banner">
      <img src="../../../static/img/news_banner.1b81b23.png" alt="" srcset="">
    </div>
    <div class="wn_content" >
      <!-- <ul class="tcf-flex tcf-justify-justify">
        <li style="line-height: 39px;">资讯动态</li>
      </ul> -->
      <keep-alive>
        <div class="wn_listbox tcf-flex tcf-justify-justify">
          <div class="wnl_slider" v-for="(item, index) in wpplSliderLast.rows" :key="index" @click="goDetails(item.id)">
          <div class="wnl_slider_border"></div>
          <img :src="item.http_pc_img_url" alt="" srcset="">
          <p class="strNewsTitle" style="height: 44px;">{{item.str_news_title}}</p>
          <p class="strKey p_after_strKey" style="height: 48px;" id="keys">{{item.str_keys}}</p>
          <ul class="wnls_bom tcf-flex tcf-justify-justify">
            <li>
              <i>{{item.str_show_time}}</i>
              <i><img src="../../../static/img/wnds_eyeicon.png" alt="" srcset="">{{item.n_eyes_count}}</i>
            </li>
            <li><img src="../../../static/img/whac_readdetail.png" alt=""></li>
          </ul>
          </div>
        <!-- <div class="wnl_slider wnl_slider_empt"></div>
        <div class="wnl_slider wnl_slider_empt"></div>
        <div class="wnl_slider wnl_slider_empt"></div> -->
      </div>
      </keep-alive>
    </div>
    <el-pagination  layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :total="wpplSliderLast.total"
                    :page-size="wpplSliderLast.rowCount"
                    class="paging"
                    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: "news",
	data(){
		return{
			wpplSliderLast: [],
      currentPage: 1,
      pagesize:6,
      rowCount: 0,
		}
  },
  created(){
		this.$parent.activeIndex = 'news'
    this.wnlSliderLastFn(this.currentPage, this.pagesize, "", "");
  },
  
  methods: {
     wnlSliderLastFn( page, per, str, typeid){
      this.axios.post(
				process.env.API_HOST + '/newslisthome',
				this.$qs.stringify({"page": page, "per": per, "str": str, "n_type_id": typeid})
			)
			.then(({data}) => {
        if(data.code === 201) {
          if (data.msg.rows.length >0 ){
            this.wpplSliderLast = data.msg
          }else {

          }
        }
			})
			.catch(error => {
				// console.log(error);
				this.$toast("网络错误，不能访问");
			})
    },
    getTypeDataFn(els){
      // console.log(els.index);
      if ( els.index == "0" ){
        this.wnlSliderLastFn(1, 10, "", 1)
      }else if( els.index == "1"  ){
        this.wnlSliderLastFn(1, 10, "", 2)
      }else if( els.index == "2"  ){
        this.wnlSliderLastFn(1, 10, "", 3)
      }
    },
    handleCurrentChange: function(currentPage){
      this.currentPage = currentPage;
      this.wnlSliderLastFn(currentPage, this.pagesize, "", "")
      // sessionStorage.setItem("currPage",this.currentPage);
    },
    goDetails(id){
      this.$router.push({
       path:"/detail?id="+id
      })
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.countNumFn(id);
    },
    countNumFn(id){
      this.axios.post(
				process.env.API_HOST + '/newsclick',
				this.$qs.stringify({"id": id})
			)
			.then(({data}) => {
        if(data.code === 201) {
        }
			}) 
    },
  },
  beforeRouteLeave(to, from, next) {
    from.meta.keepAlive = false;
    next();
  }
}
</script>
<style>
.wnds_news{
  display: inline-table;
  width: 100%;
  background: #fff;
}
.wn_content .el-tabs__active-bar {
    background-color: #658e31;
}
.wn_content .el-tabs__item.is-active,.wn_content .el-tabs__nav>div:hover {
    color: #658e31;
}
</style>

<style>
.el-pager li.active{
  color: #8eb758;
}
.el-pager li:hover{
  color: #8eb758 !important;
}
.el-pager{
  color: #666;
}
.wn_banner, .wn_banner img {
  width: 100%;
  font-size: 0;
}
.wn_content {
    width: 1140px;
    margin: 0 auto;
    font-size: 20px;
    padding-top: 60px;
    padding-bottom: 100px;
    color: #555;
}
.wn_content .el-tabs__header {
    margin: 0;
}
.wn_content .el-tabs__content {
    display: none;
}
.wn_listbox {
    margin-top: 50px;
    margin-bottom: 40px;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}
.wnl_slider {
    cursor: pointer;
    width: 364px;
    padding: 15px;
    padding-bottom: 0;
    margin-bottom: 22px;
    border: 1px solid #ddddde;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
}
.wnl_slider:hover {
  -webkit-box-shadow: 0px 0px 50px -10px #cccccc;
  box-shadow: 0px 0px 50px -10px #cccccc;
}
.wnl_slider:hover .wnl_slider_border {
  display: block;
}
.wnl_slider_empt {
    height: 0;
    padding: 0;
    margin: 0;
    border: 0;
}
.wnl_slider_border {
    display: none;
    width: 152px;
    height: 4px;
    margin-left: -76px;
    background-color: #a7c07e;
    position: absolute;
    top: -3px;
    left: 50%;
    z-index: 10;
}
.wnl_slider>img {
    width: 100%;
    height: 200px;
    display: block;
    margin: 0 auto;
}
.wnl_slider p {
    margin: 0 auto;
    font-family: myfont;
}
.wnl_slider .strKey, .wnl_slider .strNewsTitle {
    text-align: justify;
    position: relative;
}
.wnl_slider p:nth-child(3) {
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 20px;
    margin-bottom: 12px;
    font-size: 16px;
    line-height: 22px;
    color: #1f1f1f;
}
.wnl_slider p:nth-child(4) {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
    line-height: 16px;
    color: #5f5f5f;
}
.wnl_slider .strKey.p_after_strKey:after, .wnl_slider .strNewsTitle.p_after:after {
    content: "...";
    position: absolute;
    bottom: 0;
    right: 0;
    padding-left: 40px;
    background: linear-gradient(90deg,hsla(0,0%,100%,0),#fff 55%);
}
.wnls_bom {
    margin: 0 auto;
    padding: 20px 0 30px;
    font-family: myfont;
    font-size: 12px;
}
.wnls_bom li i:first-child {
    margin-right: 18px;
    color: #797979;
}
.wnls_bom li i:nth-child(2) {
    color: #a8a8a8;
    margin-left: 35px;
}
.wnls_bom li i:nth-child(2) img {
    margin-right: 8px;
}
.paging{
  text-align: center;
  margin-bottom: 50px;
  margin-top: -110px;
}
</style>





// WEBPACK FOOTER //
// src/components/page/News.vue